import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getBoardUrl } from '../services/collectifileService';

/**
 * Przekierowanie /board/:id → unitresco.collectifile.com
 * Boardy są teraz w Collectifile.
 */
export default function BoardRedirectPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate('/projects', { replace: true });
      return;
    }
    const url = getBoardUrl(id);
    window.location.href = url;
  }, [id, navigate]);

  return null;
}
